import gql from "graphql-tag";

export const UPLOAD_FILE_TO_REPORT_MUTATION = gql`
  mutation UploadFileToReport(
    $reportId: ID!
    $sheetId: ID
    $characteristicsId: ID
    $file: Upload!
    $description: String
    $fileName: String!
    $mc: Boolean!
  ) {
    uploadFileToReport(
      reportId: $reportId
      sheetId: $sheetId
      characteristicsId: $characteristicsId
      file: $file
      description: $description
      fileName: $fileName
      mc: $mc
    )
  }
`;
